import Form from "react-bootstrap/Form";
import { useState } from "react";


export default function PriceFilter(props) { 
// price range slider input to filter products
// user can select a maximum price

  const [priceCollapsed, setPriceCollapsed] = useState(false);

  // slider for price range input
  const filterHeader = (
    <Form.Label style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <span className="fw-bold">Max Price: </span>{" "}
        {parseFloat(props?.selectedPrice).toLocaleString("en-CA", {
          style: "currency",
          currency: "CAD",
          maximumFractionDigits: "0",
        })}
      </div>
      <div>

      {props?.selectedPrice !== props.defaultPrice && <i
        className="bi bi-arrow-counterclockwise me-3"
        style={{ cursor: "pointer" }}
        onClick={() => {
          props.handleChangePrice();
        }}
      ></i>}
            {priceCollapsed ? <i onClick={() => setPriceCollapsed(false)} className="bi bi-plus pointer"></i> : <i onClick={() => setPriceCollapsed(true)} className="bi bi-dash pointer"></i>}
      </div>
    </Form.Label>
  );
  return (
    <>
      {filterHeader}
      <div className={priceCollapsed ? "hide-element" : ""}>

      <Form.Range
        min={0}
        max={props.defaultPrice}
        step={10}
        value={props?.selectedPrice}
        onChange={(event) => props.handleChangePrice(event.target.value)}
        onMouseUp={props.handleSubmitPrice}
        onTouchEnd={props.handleSubmitPrice} //mobile
      />
      </div>
    </>
  );
}
